import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { FaqData, FaqGroupStatus } from "../types";

export const updateFaqStatus = async (
  faqGroupId: string,
  faqId: string,
  status: FaqGroupStatus,
) => {
  const collectionRef = collection(db, `faqGroups/${faqGroupId}/faqs`);

  await updateDoc(doc(collectionRef, faqId), {
    status,
    updatedAt: new Date(),
  });

  const faqSnapshot = await getDoc(doc(collectionRef, faqId));

  return faqSnapshot.data() as FaqData;
};
